import { useQuery } from '@tanstack/react-query';
import { platformApiFetch } from '../../api/client';

export const metricsQueryKey = ['platform', 'metrics'];

export function useMetrics() {
  return useQuery({
    queryKey: metricsQueryKey,
    queryFn: () => platformApiFetch('/api/platform/metrics'),
    staleTime: 30_000,
  });
}

export function useOrganizationMetrics(organizationUuid) {
  return useQuery({
    queryKey: ['platform', 'organizations', organizationUuid, 'metrics'],
    queryFn: () => platformApiFetch(`/api/platform/organizations/${organizationUuid}/metrics`),
    enabled: Boolean(organizationUuid),
    staleTime: 30_000,
  });
}
